import { useReveal } from "../hooks/useReveal";
import { STATS, GAMES_LIST } from "../constants";

export default function Stats() {
  const ref = useReveal();

  return (
    <>
      <div className="stats">
        {STATS.map((s, i) => (
          <div
            key={i}
            className="stat-c reveal"
            ref={i === 0 ? ref : undefined}
          >
            <div className="stat-n">{s.n}</div>
            <div className="stat-l">{s.l}</div>
          </div>
        ))}
      </div>

      {/* Social Proof Bar */}
      <div className="social-proof-bar reveal">
        <div className="spb-item">
          <span className="spb-icon">🎮</span>{" "}
          <span className="spb-val">+100</span> لعبة جاهزة الآن
        </div>
        <div className="spb-item">
          <span className="spb-icon">⚡</span> بدون تحميل{" "}
          <span className="spb-val">0%</span>
        </div>
        <div className="spb-item">
          <span className="spb-icon">🏆</span>{" "}
          <span className="spb-val">+50,000</span> لاعب سوداني
        </div>
        <div className="spb-item">
          <span className="spb-icon">📱</span> يعمل على{" "}
          <span className="spb-val">أي جهاز</span>
        </div>
      </div>

      {/* Marquee */}
      {/* <div className="mwrap" aria-hidden="true">
        <div className="mtrack">
          {[...GAMES_LIST, ...GAMES_LIST].map((g, i) => (
            <span key={i} className="mitem">🎮 {g}</span>
          ))}
        </div>
      </div> */}
    </>
  );
}
